import { FC } from 'react';

interface YoutubeIframePropTypes {
  url: string;
  className?: string;
}

export const YoutubeIframeModal: FC<YoutubeIframePropTypes> = ({
  url,
  className,
}) => {
  return (
    <div className={`iframe-video-container ${className ?? ''}`}>
      <iframe
        src={url}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  );
};
